import React from 'react';
import { FormattedMessage } from 'react-intl';

import Sidebar from 'carbon-react/lib/components/sidebar';
import Typography from 'carbon-react/lib/components/typography';

import { NonFinancialDriverTreeNode } from '../../../types';
import { DriverGroupWizardContainer } from './driver-group-wizard-container';

interface EditDriverGroupSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  row: NonFinancialDriverTreeNode;
}

export const EditDriverGroupSidebar = ({ isOpen, onClose, row }: EditDriverGroupSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="common.edit_group" defaultMessage="Edit group" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <DriverGroupWizardContainer onClose={onClose} row={row} />
  </Sidebar>
);
